import React from "react";

const ToFAQ = ({
  category = "laptop",
  title = "Masih Bingung Mau Mulai dari Mana?",
  description = "Tenang, kami sudah rangkum semua pertanyaan paling umum di sini. Klik di bawah ini untuk cek detail:",
  buttonText = "Lihat FAQ Sewa",
}) => (
  <div className="mt-12 border-t pt-6">
      <h3 className="text-base font-semibold mb-2" dangerouslySetInnerHTML={{ __html: title }} />
      <p className="text-sm" dangerouslySetInnerHTML={{ __html: description }} />
      <a
        href="#globalFaq"
        title={`Pertanyaan umum seputar layanan sewa ${category}`}
        className="mt-3 inline-block bg-blue-600 text-white px-4 py-2 rounded-full text-sm hover:bg-blue-700 transition capitalize"
        dangerouslySetInnerHTML={{ __html: buttonText + ' ' + category }}
      />
    </div>
);

export default ToFAQ;